const fullAnalysis = {
  banner: 'Coming soon:',
  intro: {
    headline: 'Would you like a full analysis?',
    copy:
      '<p>We’re working hard developing the technology to provide you with a full analysis of your man. It’s coming soon!</p><strong>Results will indicate:</strong><ul><li>Warning signs and Red Flags</li><li>Results from our B/A/S/K framework</li><li>His strengths and weaknesses</li><li>Which of 4 types of pricks you’re dealing with</li></ul><p>And if your results indicate you’re dealing with a prick, we’ll stack him up against a Good Guy for comparison.</p>',
  },
  copyBlockOne: {
    copy:
      '<p>Our B/A/S/K framework, the necessary foundation for a healthy relationship, is meant to increase your odds for a successful relationship.</p><p>We don’t predict attraction, chemistry, likes, and dislikes that may affect a relationship, but we can help predict foundational characteristics that are necessary in a healthy long term partner. And we think a deeper understanding of your budding relationship will only increases your odds for finding the real deal.</p>',
  },
};

export default fullAnalysis;



// WEBPACK FOOTER //
// ./src/locales/full-analysis.js